import React from 'react'

const Project = ({preview, name, description, source, live, techs}) => (
  <div className="col-xs-12 col-sm-6">
  <div className="p-1 mb-4 card">
    <img className="card-img-top" src={preview} alt={name + '-' + preview} />
    <div className="card-body">
      <h5 className="card-title">{name}</h5>
      <p className="card-text description">{description}</p>
      <div className="text-center mb-3">
        {
          techs.map((item) => (
            <span key={item} className="badge badge-dark m-1">{item}</span>
          ))
        }
      </div>
      <div className="text-center">
        <a href={source} className="btn btn-light btn-block m-2" target="_blank" rel="noreferrer">
          Source Code
        </a>
        <a href={live} className="btn btn-light btn-block m-2" target="_blank" rel="noreferrer">
          Live Preview
        </a>
      </div>
    </div>
  </div>
</div>
);

export default Project
